export function getScriptNonce(): string | null {
  // @ts-expect-error: window.NONCE is not defined in the Window type
  return typeof window !== 'undefined' && window?.NONCE ? window.NONCE : null
}
